const Terms = () => {
  return (
    <div className="max-w-4xl mx-auto p-8 bg-white rounded shadow my-8">
      <h1 className="text-3xl font-bold mb-2">Terms of Use & Privacy Policy</h1>
      
      <p className="mb-4 text-gray-500">Last updated: March 21, 2026</p>

      <h2 className="text-2xl font-semibold mb-2">1. Use at Your Own Risk</h2>
      <p className="mb-4 text-gray-700">
        This website is provided "as is" and "as available" without any warranties of any kind.
        To the fullest extent permitted by law, timelined.online and its operator disclaim all liability for any damages or losses arising from your use of or inability to use this website.
        We do not guarantee uninterrupted or error-free operation.
        By using this website, you agree that you do so at your own risk.
      </p>

      <h2 className="text-2xl font-semibold mb-2">2. User Content</h2>
      <p className="mb-4 text-gray-700">You are solely responsible for any content you publish or submit through the service.
        <h3>Your content must not:</h3>
        <ul className="ps-4 list-disc">
          <li>Violate any applicable laws or regulations</li>
          <li>Infringe upon the rights of any third party</li>
          <li>Contain harmful, abusive, or illegal material</li>
          <li>Cause harm to others, the website, or its operation</li>
        </ul>
      </p>

      <h2 className="text-2xl font-semibold mb-2">3. Prohibited Uses</h2>
      <h3 className="text-gray-700">You may not use this website for:</h3>
      <ul className="ps-4 list-disc text-gray-700 mb-4">
        <li>Spamming, unsolicited advertising, or any form of mass messaging</li>
        <li>Any illegal purpose or activity</li>
        <li>Harassing, threatening, or abusing others</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">4. Account Suspension and Termination</h2>
      <p className="mb-2 text-gray-700">
        We reserve the right to suspend or terminate any account at our sole discretion, without prior notice, for any reason including but not limited to:
      </p>
      <ul className="ps-4 list-disc text-gray-700 mb-4">
        <li>Violation of these terms</li>
        <li>Violation of applicable laws or regulations</li>
        <li>Any activity we deem harmful to the website, its users, or others</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">5. Information We Collect</h2>
      <p className="mb-2 text-gray-700">When you register on timelined.online, we collect:</p>
      <ul className="ps-4 list-disc text-gray-700 mb-2">
        <li>Email address</li>
        <li>Name (if provided)</li>
        <li>Password (encrypted)</li>
      </ul>
      <p className="mb-4 text-gray-700">
        When you use our service, any content you create or submit is stored as you provide it (without encryption).
      </p>

      <h2 className="text-2xl font-semibold mb-2">6. Information We Do Not Collect</h2>
      <p className="mb-2 text-gray-700">
        We do not actively collect or store IP addresses or registration timestamps. Such information may appear in email headers if you contact us, but we do not log or process this data separately.
      </p>
      <p className="mb-4 text-gray-700">
        Server logs may temporarily contain IP addresses as part of standard hosting operations. We do not access or use this data.
      </p>

      <h2 className="text-2xl font-semibold mb-2">7. How We Use Your Information</h2>
      <p className="mb-2 text-gray-700">We use your information only to:</p>
      <ul className="ps-4 list-disc text-gray-700 mb-4">
        <li>Create and manage your account</li>
        <li>Operate the service</li>
        <li>Store and display the content you create</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-2">8. Data Sharing</h2>
      <p className="mb-4 text-gray-700">
        We do not share, sell, or transfer your personal data to any third parties.
      </p>

      <h2 className="text-2xl font-semibold mb-2">9. Your Rights</h2>
      <p className="mb-4 text-gray-700">
        You may request account deletion at any time by emailing us. We will delete your account and all associated data.
      </p>

      <h2 className="text-2xl font-semibold mb-2">10. Contact</h2>
      <p className="mb-4 text-gray-700">
        For any requests or questions, contact us at: <a href="mailto:admin@timelined.online" className="text-blue-600 hover:underline">admin@timelined.online</a>
      </p>
    </div>
  );
};

export default Terms;
